import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { taxRatesQueryOptions } from '../../../../features/finance/queries'
import { EditSupplierReturnPage } from '../../../../features/purchasing/return-pages'
import { salesSettingsQueryOptions } from '../../../../features/sales/queries'

export const Route = createFileRoute('/_app/supplier-returns/$returnId/edit')({
  staticData: { crumb: 'supplierReturnEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'supplierReturns.create'),
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(salesSettingsQueryOptions),
      context.queryClient.ensureQueryData(taxRatesQueryOptions),
    ])
  },
  component: EditSupplierReturnPage,
})
